import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";
import { ReactiveFormsModule } from "@angular/forms";

import { MatCardModule } from "@angular/material/card";
import { MatSidenavModule } from '@angular/material/sidenav';

import { CommandsModule } from "@tylertech/commands-module";
import
{
    LgdCheckboxModule,
    LgdCurrencyModule,
    LgdDatePickerModule,
    LgdNumberModule,
    LgdSelectModule,
    LgdTextModule,
    LgdTypeAheadModule
} from "@tylertech/lgd-reactive-forms";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CoreModule } from "@tylertech/core-module";
import { IncodeModule } from "@tylertech/incode-module";
import { DataLoadModule } from "@tylertech/data-load-module";
import { AdvancedComponentsModule } from "@tylertech/advanced-components-module";
import { MetadataModule } from "@tylertech/metadata-module";
import { InfoTableModule } from "@tylertech/info-table-module";
import { InfoCardModule } from "@tylertech/info-card-module";

import { EntitySearchService, InputParameterService, SearchService, SearchUrlService } from "./services";
import
{
    BooleanParameterComponent,
    DateParameterComponent,
    DecimalParameterComponent,
    ExportDataComponent,
    FacetCollectionComponent,
    MetadataParameterComponent,
    MultiselectFacetComponent,
    NumberParameterComponent,
    NumberRangeComponent,
    PageBarComponent,
    ParameterCollectionComponent,
    RangedFacetComponent,
    SearchAggregateCollectionComponent,
    SearchCommandsComponent,
    SearchComponent,
    SearchMenuComponent,
    SearchSortComponent,
    SelectParameterComponent,
    TextParameterComponent,
    TypeaheadParameterComponent,
} from "./components";

const angularModules = [
    CommonModule,
    FlexModule,
    FlexLayoutModule,
    ReactiveFormsModule,
];

const angularMaterialModules = [
    MatCardModule,
    MatSidenavModule
];

const lgdModules = [
    CommandsModule,
    CommonComponentsModule,
    CoreModule,
    IncodeModule,
    DataLoadModule,
    AdvancedComponentsModule,
    InfoCardModule,
    InfoTableModule,
    MetadataModule,
    LgdCheckboxModule,
    LgdCurrencyModule,
    LgdDatePickerModule,
    LgdNumberModule,
    LgdSelectModule,
    LgdTextModule,
    LgdTypeAheadModule,
];

const exportedComponents = [
    SearchComponent,
    ParameterCollectionComponent,
    FacetCollectionComponent
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules
    ],
    declarations: [
        ...exportedComponents,
        ExportDataComponent,
        PageBarComponent,
        DecimalParameterComponent,
        TypeaheadParameterComponent,
        TextParameterComponent,
        SelectParameterComponent,
        NumberParameterComponent,
        MetadataParameterComponent,
        DateParameterComponent,
        BooleanParameterComponent,
        SearchAggregateCollectionComponent,
        SearchSortComponent,
        SearchCommandsComponent,
        RangedFacetComponent,
        NumberRangeComponent,
        MultiselectFacetComponent,
        SearchMenuComponent,
    ],
    exports: exportedComponents,
    providers: [
        InputParameterService,
        SearchUrlService,
        SearchService,
        EntitySearchService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchModule { }
